import { RootState } from "@/redux/store";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { steps } from "@/containers/pages/General/Stepper";

export const serviceSlice = createSlice({
  name: "service",
  initialState: {
    project: "default",
    login: {
      account: "",
      password: ""
    },
    activeStep: 0
  },
  reducers: {
    setProjcet(state, action: PayloadAction<string>) {
      state.project = action.payload
    },
    setLogin(state, action: PayloadAction<{ account: string, password: string }>) {
      state.login = action.payload
    },
    handleNextActiveStep(state, action: PayloadAction<void>) {
      if (steps.length - 1 >= state.activeStep) {
        state.activeStep = state.activeStep + 1;
      }
    },
    handleBackActiveStep(state, action: PayloadAction<void>) {
      if (state.activeStep > 0) {
        state.activeStep = state.activeStep - 1;
      } else {
        state.activeStep = 0;
      }

    },
  },
});

export const { setProjcet, setLogin, handleNextActiveStep, handleBackActiveStep } = serviceSlice.actions;

export const selectProject = (state: RootState) => state.service;

export default serviceSlice.reducer;
